import {
  AdsClickRounded,
  AnalyticsRounded,
  AssessmentRounded,
  CalculateRounded,
  CampaignRounded,
  CategoryRounded,
  CompareArrowsRounded,
  EmojiEventsRounded,
  ErrorOutlineRounded,
  FeedbackRounded,
  FormatListNumberedRounded,
  GroupAddRounded,
  HelpOutlineRounded,
  InsightsRounded,
  LeaderboardRounded,
  MonetizationOnRounded,
  MoneyOffRounded,
  PersonRemoveRounded,
  SavingsRounded,
  ScienceRounded,
  StarRounded,
  SummarizeRounded,
  TrendingDownRounded,
  TrendingUpRounded,
  VerifiedRounded,
  VisibilityRounded,
} from '@mui/icons-material';

import type { WelcomeSuggestion } from '@/components/shared/AgentAssistantPopup/types';

const CREATIVE_SUGGESTIONS: WelcomeSuggestion[] = [
  { label: 'What is Click Effectiveness?', icon: <HelpOutlineRounded /> },
  { label: 'List the top 5 creatives by CES', icon: <StarRounded /> },
  {
    label: 'Explain what AOV Effectiveness measures',
    icon: <HelpOutlineRounded />,
  },
  {
    label: 'Describe what Conversion Effectiveness means',
    icon: <HelpOutlineRounded />,
  },
  {
    label: "What does 'Open Effectiveness' measure?",
    icon: <HelpOutlineRounded />,
  },
  {
    label: 'Summarize the creatives with the highest Retention Effectiveness',
    icon: <GroupAddRounded />,
  },
  {
    label: 'List the creatives in the bottom 10% by CES',
    icon: <TrendingDownRounded />,
  },
  {
    label: 'Identify the creatives with the lowest conversion rate',
    icon: <TrendingDownRounded />,
  },
  {
    label: 'Identify the creatives with the highest impression volume',
    icon: <VisibilityRounded />,
  },
  {
    label: 'Identify the top 5% of creatives by Open Effectiveness',
    icon: <TrendingUpRounded />,
  },
];

const CAMPAIGN_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'List the top 5 campaigns by revenue',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'List 5 campaigns with the lowest open rates',
    icon: <TrendingDownRounded />,
  },
  {
    label: 'Find campaigns with high click rates but low conversion rates',
    icon: <AdsClickRounded />,
  },
  {
    label: 'Explain the difference between opens and auto-opens',
    icon: <HelpOutlineRounded />,
  },
  {
    label: 'List the campaigns with the highest hard bounce rates',
    icon: <ErrorOutlineRounded />,
  },
  {
    label: 'Explain how Revenue Per Send differs from RPT',
    icon: <CompareArrowsRounded />,
  },
  {
    label: 'Explain what a soft bounce means',
    icon: <HelpOutlineRounded />,
  },
  {
    label: 'What is the average CTOR for the current view?',
    icon: <AnalyticsRounded />,
  },
  {
    label: 'List the top 5 campaigns by number of unsubscribes',
    icon: <PersonRemoveRounded />,
  },
  {
    label: 'Explain how open rate is calculated',
    icon: <HelpOutlineRounded />,
  },
  {
    label: 'Identify the campaign with the highest ROI',
    icon: <TrendingUpRounded />,
  },
];

const SUBJECT_LINE_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'Rank the top 5 subject lines by open rate',
    icon: <FormatListNumberedRounded />,
  },
  {
    label: 'Rank the top 5 subject lines by revenue',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Identify the subject line with the highest CTOR',
    icon: <TrendingUpRounded />,
  },
  {
    label: "What makes a subject line 'High Reliability'?",
    icon: <VerifiedRounded />,
  },
  {
    label: 'List the top 5 subject lines by conversion rate',
    icon: <FormatListNumberedRounded />,
  },
];

const EXPERIMENT_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'What are experiments and how are they used?',
    icon: <ScienceRounded />,
  },
  {
    label: 'What is the total revenue impact from experiments?',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Which experiment currently shows the highest lift?',
    icon: <TrendingUpRounded />,
  },
  {
    label: 'Compare experiment performance across campaigns',
    icon: <CompareArrowsRounded />,
  },
  {
    label: 'Calculate the average lift across all experiments',
    icon: <CalculateRounded />,
  },
];

const SEGMENT_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'What are segment groups and how do I use them?',
    icon: <CategoryRounded />,
  },
  {
    label: 'Rank the top 5 segments by Average Order Value',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Identify segments with high conversion and low sends',
    icon: <InsightsRounded />,
  },
  {
    label: 'Summarize the average RPT across segment groups',
    icon: <SummarizeRounded />,
  },
  {
    label: 'Identify the segment group with the highest RPT',
    icon: <TrendingUpRounded />,
  },
];

const DASHBOARD_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'List the top 5 campaigns by revenue',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'List 5 campaigns with the lowest open rates',
    icon: <TrendingDownRounded />,
  },
  {
    label: 'Find campaigns with high click rates but low conversion rates',
    icon: <AdsClickRounded />,
  },
  {
    label: 'What is the average CTOR for the current view?',
    icon: <AnalyticsRounded />,
  },
  {
    label: 'Identify the campaign with the highest ROI',
    icon: <SavingsRounded />,
  },
  {
    label: 'List the top 5 creatives by CES',
    icon: <StarRounded />,
  },
  {
    label: 'Summarize the creatives with the highest Retention Effectiveness',
    icon: <GroupAddRounded />,
  },
  {
    label: 'Identify the creatives with the lowest conversion rate',
    icon: <TrendingDownRounded />,
  },
  {
    label: 'Identify the creatives with the highest impression volume',
    icon: <VisibilityRounded />,
  },
  {
    label: 'Identify the top 5% of creatives by Open Effectiveness',
    icon: <TrendingUpRounded />,
  },
  {
    label: 'Rank the top 5 subject lines by revenue',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Identify the subject line with the highest CTOR',
    icon: <TrendingUpRounded />,
  },
  {
    label: 'What is the total revenue impact from experiments?',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Which experiment currently shows the highest lift?',
    icon: <TrendingUpRounded />,
  },
  {
    label: 'Summarize the average RPT across segment groups',
    icon: <SummarizeRounded />,
  },
  {
    label: 'Identify the segment group with the highest RPT',
    icon: <TrendingUpRounded />,
  },
];

/** Shown on analytics pages that don't have a bespoke suggestion list. */
export const GENERIC_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'Summarize performance for this period',
    icon: <LeaderboardRounded />,
  },
  { label: 'Show top campaigns by revenue', icon: <EmojiEventsRounded /> },
  { label: 'Identify underperforming creatives', icon: <FeedbackRounded /> },
];

/**
 * Maps a route segment to its suggestion list. `creatives-v2` intentionally
 * matches both `creatives-v2` and `creatives-v2-new`; detail pages inherit their
 * category because they share the same segment.
 */

// Individual Campaign Suggestions
const INDIVIDUAL_CAMPAIGN_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'Provide a performance overview for this campaign',
    icon: <AssessmentRounded />,
  },
  {
    label: 'What is Revenue Per Send (RPS)?',
    icon: <HelpOutlineRounded />,
  },
  {
    label: 'Which creative generated the highest revenue?',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Which creatives resulted in zero conversions?',
    icon: <MoneyOffRounded />,
  },
  {
    label: 'What is the total revenue across all mailings?',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Identify the mailing with the highest bounce rate',
    icon: <ErrorOutlineRounded />,
  },
];

// Individual Creative Suggestions
const INDIVIDUAL_CREATIVE_SUGGESTIONS: WelcomeSuggestion[] = [
  {
    label: 'How many campaigns have used this creative?',
    icon: <CampaignRounded />,
  },
  {
    label: 'Identify the subject line with the highest RPT',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Highlight subject lines with below-average open rates',
    icon: <TrendingDownRounded />,
  },
  {
    label: 'Surface the subject line with the highest revenue',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Find the top-performing subject line by AOV',
    icon: <MonetizationOnRounded />,
  },
  {
    label: 'Show all campaigns currently using this creative',
    icon: <CampaignRounded />,
  },
  {
    label: 'Identify the campaign generating the lowest revenue',
    icon: <TrendingDownRounded />,
  },
];

const SUGGESTIONS_BY_ROUTE: Array<{
  pattern: RegExp;
  suggestions: WelcomeSuggestion[];
}> = [
  // Individual/detail pages — keep these before the listing pages
  {
    pattern: /^\/[^/]+\/analytics\/campaigns-v2\/[^/]+/,
    suggestions: INDIVIDUAL_CAMPAIGN_SUGGESTIONS,
  },
  {
    pattern: /^\/[^/]+\/analytics\/creatives-v2(?:-new)?\/[^/]+/,
    suggestions: INDIVIDUAL_CREATIVE_SUGGESTIONS,
  },

  // Analytics listing pages
  {
    pattern: /\/campaigns-v2(?:\/)?$/,
    suggestions: CAMPAIGN_SUGGESTIONS,
  },
  {
    pattern: /\/creatives-v2(?:-new)?(?:\/)?$/,
    suggestions: CREATIVE_SUGGESTIONS,
  },
  {
    pattern: /\/analytics\/content(?:\/)?$/,
    suggestions: CREATIVE_SUGGESTIONS,
  },
  {
    pattern: /\/analytics\/audiences(?:\/)?$/,
    suggestions: EXPERIMENT_SUGGESTIONS,
  },
  {
    pattern: /\/subject-lines-v2(?:\/)?$/,
    suggestions: SUBJECT_LINE_SUGGESTIONS,
  },
  {
    pattern: /\/experiments-v2(?:\/)?$/,
    suggestions: EXPERIMENT_SUGGESTIONS,
  },
  {
    pattern: /\/segments-v2(?:\/)?$/,
    suggestions: SEGMENT_SUGGESTIONS,
  },
  {
    pattern: /\/dashboard(?:\/)?$/,
    suggestions: DASHBOARD_SUGGESTIONS,
  },
];

/** Returns the full suggestion list for the current path, or the generic fallback. */
export const getWelcomeSuggestionsForPath = (
  pathname: string,
): WelcomeSuggestion[] =>
  SUGGESTIONS_BY_ROUTE.find(({ pattern }) => pattern.test(pathname))
    ?.suggestions ?? GENERIC_SUGGESTIONS;

/** Returns up to `count` distinct random suggestions from `list`. */
export const pickRandom = (
  list: WelcomeSuggestion[],
  count = 3,
): WelcomeSuggestion[] => {
  const shuffled = [...list];

  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled.slice(0, count);
};
